/**
 * Shared index-page content for legacy-freeze asset order routes (buy/order/[offerStatusOrId], sell/order/[offerStatusOrId]).
 * Renders FinishTradeWithDesktopWrapper for finish statuses (FINISHED/FAILED) or AcceptOfferIndexPage otherwise.
 * See trade/AccepBackwardsCompatibilityInterceptor/legacy-freeze/README.md
 */

import { notFound } from 'next/navigation';
import { isOrderFinishRouteStatus } from '@bts-web/data-layer/server';
import { AcceptOfferIndexPage } from '../AcceptOfferIndexPage';
import { FinishTradeWithDesktopWrapper } from '../../FinishTrade/FinishTradeWithDesktopWrapper.use-server/FinishTradeWithDesktopWrapper.use-server';

interface LegacyFreezeAcceptOfferIndexPageProps {
  params: Promise<{ assetId?: string; offerStatusOrId?: string }>;
  searchParams?: Promise<Record<string, string | undefined>>;
}

export async function LegacyFreezeAcceptOfferIndexPage({
  params,
  searchParams,
}: LegacyFreezeAcceptOfferIndexPageProps) {
  const awaitedParams = await params;

  const assetId = awaitedParams.assetId;

  const segment = awaitedParams.offerStatusOrId;

  if (assetId == null || segment == null) {
    notFound();
  }

  const search = searchParams != null ? await searchParams : {};

  if (isOrderFinishRouteStatus(segment)) {
    return (
      <FinishTradeWithDesktopWrapper
        params={Promise.resolve({
          assetId,
          operation: 'order',
          offerTransactionStatus: segment,
          offerId: search?.offerId,
        })}
        searchParams={Promise.resolve((search ?? {}) as Record<string, string>)}
      />
    );
  }

  return (
    <AcceptOfferIndexPage
      params={Promise.resolve({
        assetId,
        operation: 'order',
        offerId: segment,
        state: '',
      })}
      searchParams={
        Promise.resolve(search ?? {}) as Promise<{
          targetAssetId: string;
          amount: string;
          amountFor: 'SOURCE' | 'TARGET';
        }>
      }
    />
  );
}
